
<input class="form-control" type="file" name="file" accept="audio/*" (change)="handleInputChange($event)">

<div class="row" *ngIf="audioUrl">
    <div class="col">
        <audio controls="controls" [src]="audioUrl">
            Your browser does not support the audio element.
        </audio>
    </div>
    <div class="col">
        <button type="button" nbButton size="medium" status="danger" (click)="deleteFile()">Delete</button>
    </div>
</div>
<ng-container *ngIf="progress as percent">
    <div class="row">
        <progress [value]="percent" max="100"></progress>
    </div>
</ng-container>
